import React from 'react';

import EventTeaser from './Teaser';
import EventDetail from './Detail';

const NodeEvent = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <EventTeaser {...props} />;
  }

  return <EventDetail {...props} />;
};

export default NodeEvent;
